@if (!previewMode()) {
  @if (units?.length) {
    @for (unit of units; track $index) {
      <app-card-item class="cursor-pointer rounded-xl" (click)="toggle.emit(unit)" [isGray]="true"
                     [isCheckbox]="isCheckbox()" [isChevronIcon]="isChevronIcon()"
                     [isChecked]="isChecked(unit)" [isDeleteIcon]="isDeleteIcon()">
        <ng-container left>
          <div class="unit-icon bg-blue rounded-full mr-4 w-[30px] h-[30px] flex items-center justify-center">
            <app-icon size="small" [name]="getFacetIcon(unit.lense.alias)" class="text-white"></app-icon>
          </div>
          <div class="text-container">
            <div class="unit-title">
              {{ unit.title }}
            </div>
            <div class="unit-subtitle">
              {{ getUnitSubTitle(unit) }}
            </div>
          </div>
        </ng-container>
      </app-card-item>
    }
  }
} @else {
  @if (facets && facets.length) {
    @for (facet of facets; track $index) {

      <app-card-item
        class="cursor-pointer rounded-xl"
        (click)="edit.emit(facet)"
        [isGray]="true"
        [isCheckbox]="isCheckbox()"
        [isChevronIcon]="isChevronIcon()"
        [isDeleteIcon]="isDeleteIcon()"
        (delete)="delete.emit(facet)"
      >
        <ng-container left>
          <div class="bg-blue rounded-full mr-4 w-[30px] h-[30px] min-w-[30px] flex items-center justify-center">
            <app-icon size="small" [name]="getFacetIcon(facet.alias)" class="text-white"></app-icon>
          </div>
          <div class="texts">
            <div class="facet-name">
              {{ facet.name }}
            </div>
            <div class="unit-titles">
              {{ getUnitNames(facet) }}
            </div>
          </div>
        </ng-container>
      </app-card-item>

    }
  }
}

